/**
 * Tooltip for dynamically inserted elements
 * @requires https://getbootstrap.com
 * @requires https://popper.js.org/
 */

export default (() => {
  const initializeTooltip = (element) => {
    new bootstrap.Tooltip(element, { trigger: 'hover' })
  }

  const observeTooltips = () => {
    const tooltipContainer = document.body

    // Initialize tooltips for any existing elements
    document
      .querySelectorAll('[data-bs-toggle="tooltip"]')
      .forEach(initializeTooltip)

    // Observe for newly added elements
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            node.matches('[data-bs-toggle="tooltip"]')
          ) {
            initializeTooltip(node)
          } else if (node.nodeType === 1) {
            node
              .querySelectorAll('[data-bs-toggle="tooltip"]')
              .forEach(initializeTooltip)
          }
        })
      })
    })

    observer.observe(tooltipContainer, { childList: true, subtree: true })
  }

  observeTooltips()
})()
